import { Pipe, PipeTransform } from "@angular/core";

interface MergedTailoringConditionEntry {
	breadcrumb: string;
	query: {
		name: string;
		answers: {
			name: string;
			identity: string;
			conditionTypes: string[];
			allowedOperations: StringToBoolean;
		}[];
	};
}

@Pipe({
	name: "mergeConditions",
	pure: true,
})
export class MergeConditionsPipe implements PipeTransform {
	transform(
		tailoringEntries: stages.process.ViewableTailoringCondition[],
		_args?: unknown,
	): MergedTailoringConditionEntry[] {
		const result: MergedTailoringConditionEntry[] = [];
		for (const entry of tailoringEntries) {
			const existingEntry = result.find(
				(value) => value.breadcrumb === entry.breadcrumb && value.query.name === entry.queryName,
			);
			if (existingEntry) {
				const existingAnswer = existingEntry.query.answers.find((answer) => answer.identity === entry.answerIdentity);
				if (existingAnswer) {
					existingAnswer.conditionTypes.push(entry.conditionType);
				} else {
					existingEntry.query.answers.push({
						name: entry.answerName,
						identity: entry.answerIdentity,
						conditionTypes: [entry.conditionType],
						allowedOperations: entry.allowedOperations,
					});
				}
			} else {
				result.push({
					breadcrumb: entry.breadcrumb,
					query: {
						name: entry.queryName,
						answers: [
							{
								name: entry.answerName,
								identity: entry.answerIdentity,
								conditionTypes: [entry.conditionType],
								allowedOperations: entry.allowedOperations,
							},
						],
					},
				});
			}
		}
		return result;
	}
}
